<template>
  <div id="input-spin-quiz">
    <div class="input-spin-container w-100">
      <b-input
        :id="inputId"
        :name="nameValue"
        class="w-100"
        :class="[{ bypass: isInputDisabled }, customClass ? customClass : '']"
        type="number"
        @blur="onBlurNumber"
        @input="onInputNumber"
        v-model="newValue"
        @mousewheel.native="$event.preventDefault()"
      />
      <span class="text-spin">{{ isText }}</span>
      <icon-spin-plus
        class="spin-plus bypass"
        :class="[
          isDisabled ? 'spin-disabled' : '',
          maxValue == 0 || maxValue > newValue ? '' : 'spin-disabled',
        ]"
        :style="resolveSpinMode"
        @click.native="onSpin('plus')"
      />
      <icon-spin-minus
        class="spin-minus bypass"
        :class="[
          isDisabled ? 'spin-disabled' : '',
          minValue == newValue ? 'spin-disabled' : '',
        ]"
        :style="resolveSpinMode"
        @click.native="onSpin('minus')"
      />
    </div>
  </div>
</template>

<script>
import IconSpinPlus from "@/@core/components/svg/input-spin/IconSpinPlusQuiz.vue";
import IconSpinMinus from "@/@core/components/svg/input-spin/IconSpinMinusQuiz.vue";
import {
  computed,
  onBeforeMount,
  ref,
  watch,
  getCurrentInstance,
} from "@vue/composition-api";
export default {
  props: {
    mode: { type: String, default: "add" },
    numValue: { type: Number, default: 0 },
    addValue: { type: Number, default: 0 },
    isInputDisabled: { type: Boolean, default: true },
    minValue: { type: Number, default: 0 },
    maxValue: { type: Number, default: 0 },
    isText: { type: String, default: "" },
    customClass: { type: String, default: "" },
    isDisabled: { type: Boolean, default: false },
    nameValue: { type: String, default: "" },
    inputId: { type: String, default: "" },
  },
  components: { IconSpinPlus, IconSpinMinus },
  setup(props) {
    const vm = getCurrentInstance().proxy;
    const MODE_ADD = "add";
    const MODE_REMOVE = "remove";
    const MODE_DISABLED = "disabled";

    const newValue = ref("0");

    const resolveSpinMode = computed(() => {
      switch (props.mode) {
        case MODE_ADD:
          return {
            fill: "#64a6ec",
            "pointer-events": "all",
          };
        case MODE_REMOVE:
          return {
            fill: "#AD0D00",
            "pointer-events": "all",
          };
        case MODE_DISABLED:
          return {
            fill: "#C4C4C4",
            "pointer-events": "none",
          };
        default:
          break;
      }
    });

    const onSpin = (spinType = "plus") => {
      if (props.addValue) {
        if (spinType == "plus") {
          newValue.value += props.addValue;
        } else {
          newValue.value -= props.addValue;
        }
      } else {
        if (spinType == "plus") {
          newValue.value++;
        } else {
          newValue.value--;
        }
      }

      if (newValue.value < 0) {
        newValue.value = 0;
        return;
      }
    };

    const onInputNumber = (e) => {
      if (newValue.value == "") return (newValue.value = 0);

      if (!e) {
        setTimeout(() => {
          newValue.value = 0;
          return 0;
        }, 1);
      }

      let num = e.replace(/\D/g, "");
      newValue.value = Number.parseInt(num);
      return num;
    };

    const onBlurNumber = (e) => {
      if (!props.minValue && !props.maxValue) return;

      let num = e.target.value.replace(/\D/g, "");

      if (Number.parseInt(num) < props.minValue) {
        setTimeout(() => {
          newValue.value = props.minValue;
        }, 1);
      } else if (Number.parseInt(num) > props.maxValue) {
        setTimeout(() => {
          newValue.value = props.maxValue;
        }, 1);
      } else {
        setTimeout(() => {
          newValue.value = Number.parseInt(num);
        }, 1);
      }
    };

    watch(newValue, () => {
      vm.$emit("update-number", Number.parseInt(newValue.value));
    });

    watch(
      () => props.numValue,
      () => {
        newValue.value = props.numValue;
        if (props.numValue) {
          if (props.maxValue) {
            if (props.numValue > props.maxValue) {
              newValue.value = props.maxValue;
            }
          }
        }
      }
    );

    onBeforeMount(() => {
      newValue.value = props.numValue;
    });

    return {
      newValue,
      resolveSpinMode,
      onSpin,
      onInputNumber,
      onBlurNumber,
    };
  },
};
</script>

<style scoped>
#input-spin-quiz .input-spin-container {
  position: relative;
  width: 195px !important;
}

#input-spin-quiz .input-spin-container > input {
  border-radius: 8px;
  border: 1px solid #d8d6de;
  /* text-align: center; */
  height: 35px;
}

#input-spin-quiz .input-spin-container .spin-plus {
  width: 25px;
  position: absolute;
  top: -2px;
  right: 5px;
  fill: #f4f5f5 !important;
  cursor: pointer;
}

#input-spin-quiz .input-spin-container .spin-minus {
  width: 25px;
  position: absolute;
  top: -2px;
  right: 35px;
  fill: #f4f5f5 !important;
  pointer-events: all;
  cursor: pointer;
}

#input-spin-quiz .text-spin {
  position: absolute;
  right: 65px;
  top: 5px;
  color: #cecece;
}

#input-spin-quiz .input-spin-container .spin-disabled {
  pointer-events: none !important;
  cursor: none;
}
</style>
